
import accordeon from './components/accordeon';
import search from './components/search';
import subscribePopup from './components/subscribe-popup';
import tabs from './components/tabs';
import collectionsArchive from './components/collections-slider';
import passwordPage from './components/password-page';
import productsSlide from './components/vertical-scroll-pagination';

import sizeGuide from './components/size-guide';
import animation from './components/animation';

import collectionInside from './components/collection-inside';
import productPage from './components/product-page';
import teaser from './components/teaser';
import collectionsSlider from './components/collections-slider';
import videoPlayer from './components/videoPlayer';
import goback from "./components/goback";
import setActiveLink from './components/setActiveLink';
import dropdown from './components/dropdown';
import cart from './components/cart';
import product from './components/product';
import FixedAside from './helpers/Fixed-aside';
import productList from './components/product-list';

export default () => {
    animation();
    
    subscribePopup();
    accordeon();
    search();
    tabs();
    collectionsArchive();
    passwordPage();
    productsSlide();
    sizeGuide();
    productList();
  
    
    collectionInside();
    productPage();
    teaser();
    
    videoPlayer()
    goback();
    setActiveLink();
    dropdown();
    cart();
    product();
    coll();
    infoBar();
   
    function coll(){
        const leftSide = document.querySelector('[data-fixed]');
        const cont = document.querySelector('[data-collection-grid]');
        if (leftSide && cont){
            let props = {
                container: cont,
                aside: leftSide,
                fixedHeader: true
            }
    
            let a = new FixedAside(props)
            a.init();
        }
       
    }
    

    function infoBar(){
        const info= document.querySelector('.info-bar');
        if (!info) return
        if(info.dataset.show == 'home' && info.dataset.pageName == 'homePage'){
            info.style.display = 'block'
            document.querySelector('body').classList.add('header__info-bar');
        } 
        else if(info.dataset.show == 'home' && info.dataset.pageName != 'homePage'){
            document.querySelector('body').classList.remove('header__info-bar');
            info.style.display = 'none';
        }
        else if((info.dataset.show == 'all' && info.dataset.pageName == 'product' ) || (info.dataset.show == 'all' && info.dataset.pageName == 'list' )){
            document.querySelector('body').classList.remove('header__info-bar');
            info.style.display = 'none';
        }
        else if((info.dataset.show == 'all' && info.dataset.pageName != 'product' && info.dataset.pageName != 'list') ){
            info.style.display = 'block'
            document.querySelector('body').classList.add('header__info-bar');
        }
    }
}
